import { Injectable, EventEmitter } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, throwError } from 'rxjs';
import { ResultModel } from 'src/app/core/models/response/base.model';
import { HttpEvent, HttpRequest, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { JwtService } from './jwt.service';

import { HttpHeaders } from '@angular/common/http';
import { Globals } from '../globals';
import { catchError } from 'rxjs/operators';
import { UserMenuService } from 'src/app/users/services/user-menu.service';
import { GlobalService } from './global.service';
@Injectable()
export class MasterService {
  galleryData = new EventEmitter<any>();
  profileData = new EventEmitter<any>();
  userSwitchLang = new EventEmitter<any>();
  manageBrandingData = new EventEmitter<any>();
  langCustomizeEmit = new EventEmitter<any>();

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private jwtService: JwtService,
    public globals: Globals,
    private userMenuService: UserMenuService,
    private globalService: GlobalService,
  ) {}

  /** Stamp permission NameKey onto hotel-admin offering payloads when the caller omitted Route. */
  private withPermissionRoute(reqModel: any, permissionRoute: string) {
    const payload =
      reqModel && typeof reqModel === 'object' && !Array.isArray(reqModel)
        ? reqModel
        : {};
    if (!payload.Route && permissionRoute) {
      payload.Route = permissionRoute;
    }
    return payload;
  }

  private categoryPermissionRoute(reqModel: any): string {
    const type = String(reqModel?.ModuleType || reqModel?.moduleType || '')
      .toLowerCase()
      .trim();
    const map: Record<string, string> = {
      tour: 'tours',
      tours: 'tours',
      service: 'services',
      services: 'services',
      restaurant: 'restaurants',
      restaurants: 'restaurants',
    };
    return map[type] || '';
  }

  private setAwsHeaders(): Headers {
    const headersConfig = {
      'Content-Disposition': 'attachment',
      'x-amz-server-side-encryption': 'AES256',
    };
    return new Headers(headersConfig);
  }

  private formatErrors(error: any) {
    return throwError(error);
  }

  gethotelLangTranslate(): string {
    if (!window.localStorage['hotelLangTranslate']) {
      return this.globals.hotelLangTranslate;
    } else {
      return window.localStorage['hotelLangTranslate'];
    }
  }

  getuserLangTranslate(): string {
    if (!window.localStorage['userLangTranslate']) {
      return this.globals.userLangTranslate;
    } else {
      return window.localStorage['userLangTranslate'];
    }
  }

  getLangSaveProperty() {
    if (!window.localStorage['langSaveProperty']) {
      return this.globals.langSaveProperty;
    } else {
      return window.localStorage['langSaveProperty'];
    }
  }
  getLangSaveValue() {
    if (!window.localStorage['langSaveValue']) {
      return this.globals.langSaveValue;
    } else {
      return window.localStorage['langSaveValue'];
    }
  }

  getManageBranding(req) {
    this.userMenuService.fetchManageBrand(req).subscribe(
      (response) => {
        if (response.Status) {
          this.manageBrandingData.next({
            error: null,
            Data: response.Data,
          });
        } else {
          this.globalService.handleApiError(response);
        }
      },
      (error) => {
        this.globalService.handleApiError(error);
        this.manageBrandingData.next({
          error: error,
          Data: null,
        });
      },
    );
  }

  deleteLogoImage(reqModel): Observable<ResultModel> {
    const route = '/hotel/deleteLogoImage';
    return this.apiService.delete<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'manage-branding')
    );
  }

  getTimezones(data = null): Observable<ResultModel> {
    const route = '/getTimezones';
    return this.apiService.get<ResultModel>(route, data);
  }

  getAwsSignedUrl(data): Observable<ResultModel> {
    const route = '/hotel/getAwsSignedUrl';
    return this.apiService.post<ResultModel>(route, data);
  }

  putObjectIntoBucket(data: any, file: any): Observable<HttpEvent<{}>> {
    const formdata: FormData = new FormData();
    formdata.append('file', file);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': file.type,
        'x-amz-acl': 'private',
        responseType: 'text',
        observe: 'response',
      }),
    };
    const req = new HttpRequest('PUT', data, file, httpOptions);

    return this.http.request(req);
    /*return this.http.put(data, formdata, httpOptions)
    .pipe(catchError(this.formatErrors));*/
    //return this.http.put(data, formdata, httpOptions);
  }

  deleteObjectFromBucket(data: any, imgType: string): Observable<{}> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': imgType,
        'x-amz-acl': 'private',
        responseType: 'text',
        observe: 'response',
      }),
    };
    // const req = new HttpRequest('DELETE',data,httpOptions);

    // return this.http.request(req);

    return this.http.delete(data).pipe(catchError(this.formatErrors));
  }

  /*pushFileToStorage(file): Observable<HttpEvent<{}>> {
    
    const formdata: FormData = new FormData();
    const authToken = this.jwtService.getToken();
    
    formdata.append('file', file);

    

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'my-auth-token'
      })
    };
    const route = '/hotel/uploadImage';
    const req = new HttpRequest('PUT',`${environment.apiUrl}${route}`, formdata,httpOptions);
 
    return this.http.request(req);
  }*/

  getHotelBanner(reqModel): Observable<ResultModel> {
    const route = '/hotel/getHotelBanner';
    return this.apiService.get<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'homepage-menu')
    );
  }

  getBanner(reqModel): Observable<ResultModel> {
    const route = '/getBanner';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  getHotelAboutUs(reqModel): Observable<ResultModel> {
    const route = '/hotel/getHotelAboutUs';
    return this.apiService.get<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'homepage-menu')
    );
  }

  getAboutUs(reqModel): Observable<ResultModel> {
    const route = '/getAboutUs';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  addHotelBanner(reqModel): Observable<ResultModel> {
    const route = '/hotel/addHotelBanner';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'homepage-menu')
    );
  }

  addHotelAboutUs(reqModel): Observable<ResultModel> {
    const route = '/hotel/addHotelAboutUs';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'homepage-menu')
    );
  }

  matchCurrentPass(reqModel): Observable<ResultModel> {
    const route = '/matchCurrentPass';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  changePass(reqModel): Observable<ResultModel> {
    const route = '/changePass';
    return this.apiService.post<ResultModel>(route, reqModel);
  }
  changePassword(reqModel, headers?): Observable<ResultModel> {
    const route = '/updatePassword';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  getCustomizeDetail(reqModel): Observable<ResultModel> {
    const route = '/getCustomizeDetail';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  updateCustomizeDetail(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateCustomizeDetail';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'homepage-menu')
    );
  }

  getGalleryTitle(reqModel): Observable<ResultModel> {
    const route = '/getGalleryTitle';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  addGalleryTitle(reqModel): Observable<ResultModel> {
    const route = '/hotel/addGalleryTitle';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'homepage-menu')
    );
  }

  /**-------Language  Save ---------------------------------------------------------- */

  getHotelLangSetUp(reqModel): Observable<ResultModel> {
    const route = '/getHotelLangSetUp';
    return this.apiService.get<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'language')
    );
  }

  updateHotelLangSetUp(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateHotelLangSetUp';
    return this.apiService.put<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'language')
    );
  }

  /**-------Home Page Banner ---------------------------------------------------------- */
  deleteBannerImage(reqModel): Observable<ResultModel> {
    const route = '/hotel/deleteBannerImage';
    return this.apiService.delete<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'homepage-menu')
    );
  }

  /**-------Rooms Service---------------------------------------------------------- */
  addRoomType(reqModel): Observable<ResultModel> {
    const route = '/hotel/addRoomType';
    return this.apiService.post<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  updateRoomType(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateRoomType';
    return this.apiService.put<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  fetchRoomtypes(reqModel): Observable<ResultModel> {
    const route = '/hotel/fetchRoomtypes';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  fetchRoomBookings(reqModel): Observable<ResultModel> {
    const route = '/hotel/showBookings';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  deleteRoomType(reqModel): Observable<ResultModel> {
    const route = '/hotel/deleteRoomType';
    return this.apiService.delete<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  addAmentie(reqModel): Observable<ResultModel> {
    const route = '/hotel/addAmentie';
    return this.apiService.post<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  addGroupAmenties(reqModel): Observable<ResultModel> {
    const route = '/hotel/addGroupAmenties';
    return this.apiService.post<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  fetchAmenitiesList(reqModel): Observable<ResultModel> {
    const route = '/hotel/fetchAmenitiesList';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  updateAmentie(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateAmentie';
    return this.apiService.put<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  addRoom(reqModel): Observable<ResultModel> {
    const route = '/hotel/addRoom';
    return this.apiService.post<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  updateRoom(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateRoom';
    return this.apiService.put<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  showRoomListsAdmin(reqModel): Observable<ResultModel> {
    const route = '/hotel/showRoomLists';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  showRoomLists(reqModel): Observable<ResultModel> {
    const route = '/showRoomLists';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  singleRoomShow(reqModel): Observable<ResultModel> {
    const route = '/singleRoomShow';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  singleRoomBooking(reqModel): Observable<ResultModel> {
    const route = '/singleRoomBooking';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  suggestedRoomShow(reqModel): Observable<ResultModel> {
    const route = '/getSugestedRooms';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  singleRoomEdit(reqModel): Observable<ResultModel> {
    const route = '/hotel/singleRoomEdit';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  singleRoomDelete(reqModel): Observable<ResultModel> {
    const route = '/hotel/singleRoomDelete';
    return this.apiService.delete<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  checkRoomTypeAlreadyChoosed(reqModel): Observable<ResultModel> {
    const route = '/hotel/checkRoomTypeAlreadyChoosed';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  showSingleRoomType(reqModel): Observable<ResultModel> {
    const route = '/hotel/showSingleRoomType';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  showAmenitiesIcons(reqModel): Observable<ResultModel> {
    const route = '/showAmenitiesIcons';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  showSingleAmentie(reqModel): Observable<ResultModel> {
    const route = '/hotel/showSingleAmentie';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  /**-------Resturant Service---------------------------------------------------------- */
  addResturantType(reqModel): Observable<ResultModel> {
    const route = '/hotel/addResturantType';
    return this.apiService.post<ResultModel>(route, this.withPermissionRoute(reqModel, 'restaurants'));
  }

  fetchResturantTypes(reqModel): Observable<ResultModel> {
    const route = '/hotel/fetchResturantTypes';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'restaurants'));
  }

  addResturant(reqModel): Observable<ResultModel> {
    const route = '/hotel/addResturant';
    return this.apiService.post<ResultModel>(route, this.withPermissionRoute(reqModel, 'restaurants'));
  }

  showResturantLists(reqModel): Observable<ResultModel> {
    const route = '/showResturantLists';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  showResturantListsAdmin(reqModel): Observable<ResultModel> {
    const route = '/hotel/showResturantLists';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'restaurants'));
  }

  singleResturantEdit(reqModel): Observable<ResultModel> {
    const route = '/hotel/singleResturantEdit';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'restaurants'));
  }

  updateResturant(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateResturant';
    return this.apiService.put<ResultModel>(route, this.withPermissionRoute(reqModel, 'restaurants'));
  }

  singleResturantShow(reqModel): Observable<ResultModel> {
    return this.apiService.get<ResultModel>('/singleResturantShow', reqModel);
  }

  validateRestaurantTableToken(reqModel): Observable<ResultModel> {
    const route = '/restaurant/table-token';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  singleResturantDelete(reqModel): Observable<ResultModel> {
    const route = '/hotel/singleResturantDelete';
    return this.apiService.delete<ResultModel>(route, this.withPermissionRoute(reqModel, 'restaurants'));
  }

  /**Hotel Guide */
  addHotelGuide(reqModel): Observable<ResultModel> {
    const route = '/hotel/addHotelGuide';
    return this.apiService.post<ResultModel>(route, this.withPermissionRoute(reqModel, 'hotelguide'));
  }

  fetchHotelGuidesListAdmin(reqModel): Observable<ResultModel> {
    const route = '/hotel/fetchHotelGuidesList';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'hotelguide'));
  }

  fetchHotelGuidesList(reqModel): Observable<ResultModel> {
    const route = '/fetchHotelGuidesList';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  showSingleHotelGuide(reqModel): Observable<ResultModel> {
    const route = '/hotel/showSingleHotelGuide';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'hotelguide'));
  }

  updateHotelGuide(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateHotelGuide';
    return this.apiService.put<ResultModel>(route, this.withPermissionRoute(reqModel, 'hotelguide'));
  }

  deleteHotelGuide(reqModel): Observable<ResultModel> {
    const route = '/hotel/deleteHotelGuide';
    return this.apiService.delete<ResultModel>(route, this.withPermissionRoute(reqModel, 'hotelguide'));
  }

  rearrangeGuides(reqModel): Observable<ResultModel> {
    const route = '/hotel/rearrangeGuides';
    return this.apiService.put<ResultModel>(route, this.withPermissionRoute(reqModel, 'hotelguide'));
  }

  /**-------Home Page Room ---------------------------------------------------------- */
  addRoomTitle(reqModel): Observable<ResultModel> {
    const route = '/hotel/addRoomTitle';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'homepage-menu')
    );
  }
  getRoomTitle(reqModel): Observable<ResultModel> {
    const route = '/getRoomTitle';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  updateRoomHomeStatus(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateRoomHomeStatus';
    return this.apiService.put<ResultModel>(route, reqModel);
  }

  updateRoomImages(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateRoomImages';
    return this.apiService.put<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  /**-------Home Page Resturant---------------------------------------------------------- */
  addResturantTitle(reqModel): Observable<ResultModel> {
    const route = '/hotel/addResturantTitle';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'homepage-menu')
    );
  }
  getResturantTitle(reqModel): Observable<ResultModel> {
    const route = '/getResturantTitle';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  showSingleResturantType(reqModel): Observable<ResultModel> {
    const route = '/hotel/showSingleResturantType';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'restaurants'));
  }

  updateResturantType(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateResturantType';
    return this.apiService.put<ResultModel>(route, this.withPermissionRoute(reqModel, 'restaurants'));
  }

  deleteResturantType(reqModel): Observable<ResultModel> {
    const route = '/hotel/deleteResturantType';
    return this.apiService.delete<ResultModel>(route, this.withPermissionRoute(reqModel, 'restaurants'));
  }

  updateResturantHomeStatus(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateResturantHomeStatus';
    return this.apiService.put<ResultModel>(route, reqModel);
  }

  updateResturantImages(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateResturantImages';
    return this.apiService.put<ResultModel>(route, this.withPermissionRoute(reqModel, 'restaurants'));
  }

  /**-------About Us detail---------------------------------------------------------- */

  addAboutUsDetail(reqModel): Observable<ResultModel> {
    const route = '/hotel/addAboutUsDetail';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'about')
    );
  }

  getAboutUsDetailHotel(reqModel): Observable<ResultModel> {
    const route = '/hotel/getAboutUsDetail';
    return this.apiService.get<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'about')
    );
  }

  getAboutUsDetail(reqModel): Observable<ResultModel> {
    const route = '/getAboutUsDetail';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  updateAboutUsDetail(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateAboutUsDetail';
    return this.apiService.get<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'about')
    );
  }

  singleAmenitiesDelete(reqModel): Observable<ResultModel> {
    const route = '/hotel/singleAmenitiesDelete';
    return this.apiService.delete<ResultModel>(route, this.withPermissionRoute(reqModel, 'rooms'));
  }

  /**-------Roles Get AdminPermissions---------------------------------------------------------- */

  getAdminPermissions(reqModel): Observable<ResultModel> {
    const route = '/hotel/getAdminPermissions';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  saveRole(reqModel): Observable<ResultModel> {
    const route = '/hotel/saveRole';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'roles-permissions')
    );
  }

  listRoles(reqModel): Observable<ResultModel> {
    const route = '/hotel/listRoles';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  editRole(reqModel): Observable<ResultModel> {
    const route = '/hotel/editRole';
    return this.apiService.get<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'roles-permissions')
    );
  }

  updateRole(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateRole';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'roles-permissions')
    );
  }

  /**-------Get Department List---------------------------------------------------------- */
  getDepartmentLists(reqModel): Observable<ResultModel> {
    const route = '/hotel/getDepartmentList';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  getDepartmentList(reqModel): Observable<ResultModel> {
    const route = '/hotel/getDepartmentListForOfferings';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  /**-------Add staff-------------------------------------------------------------------- */
  addstaff(reqModel): Observable<ResultModel> {
    const route = '/hotel/addstaff';
    return this.apiService.post<ResultModel>(route, this.withPermissionRoute(reqModel, 'staff'));
  }
  updatestaff(reqModel): Observable<ResultModel> {
    const route = '/hotel/updatestaff';
    return this.apiService.put<ResultModel>(route, this.withPermissionRoute(reqModel, 'staff'));
  }

  checkActivate(reqModel): Observable<ResultModel> {
    const route = '/hotel/checkActivate';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'staff'));
  }

  getStaffList(reqModel): Observable<ResultModel> {
    const route = '/hotel/getStaffList';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'staff'));
  }

  getStaff(reqModel): Observable<ResultModel> {
    const route = '/showAsignStaffList';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  getRestaurantStaffList(reqModel): Observable<ResultModel> {
    const route = '/hotel/getRestaurantStaffList';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  singleStaffShow(reqModel): Observable<ResultModel> {
    const route = '/hotel/singleStaffShow';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'staff'));
  }
  staffResendInvitation(reqModel): Observable<ResultModel> {
    const route = '/hotel/staffResendInvitation';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'staff'));
  }

  setStaffPassword(reqModel): Observable<ResultModel> {
    const route = '/hotel/setStaffPassword';
    return this.apiService.put<ResultModel>(route, reqModel);
  }

  deleteStaff(reqModel): Observable<ResultModel> {
    const route = '/hotel/deleteStaff';
    return this.apiService.delete<ResultModel>(route, this.withPermissionRoute(reqModel, 'staff'));
  }

  deleteRole(reqModel): Observable<ResultModel> {
    const route = '/hotel/deleteRole';
    return this.apiService.delete<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'roles-permissions')
    );
  }

  /**-------Guest Permission List-------------------------------------------------------------------- */
  guestPermissionList(reqModel): Observable<ResultModel> {
    const route = '/hotel/guestPermissionList';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  saveGuestRole(reqModel): Observable<ResultModel> {
    const route = '/hotel/saveGuestRole';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  getGuestPermission(reqModel): Observable<ResultModel> {
    const route = '/hotel/getGuestPermission';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  filterStaff(reqModel): Observable<ResultModel> {
    const route = '/hotel/filterStaff';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'staff'));
  }

  manageOrder(reqModel): Observable<ResultModel> {
    const route = '/hotel/manageOrder';
    return this.apiService.put<ResultModel>(route, reqModel);
  }

  matchStaffEmail(reqModel): Observable<ResultModel> {
    const route = '/hotel/matchStaffEmail';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'staff'));
  }

  //

  manageRestaurantGuest(reqModel): Observable<ResultModel> {
    const route = '/hotel/manageRestaurantGuest';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  /**-------Department-------------------------------------------------------------------- */

  addDepartment(reqModel): Observable<ResultModel> {
    const route = '/hotel/addDepartment';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'department')
    );
  }

  editDepartment(reqModel): Observable<ResultModel> {
    const route = '/hotel/editDepartment';
    return this.apiService.get<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'department')
    );
  }

  updateDepartment(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateDepartment';
    return this.apiService.put<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'department')
    );
  }

  deleteDepartment(reqModel): Observable<ResultModel> {
    const route = '/hotel/deleteDepartment';
    return this.apiService.delete<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'department')
    );
  }

  /**-------Inclusion /Exclusion-------------------------------------------------------------------- */
  addInclusion(reqModel): Observable<ResultModel> {
    const route = '/hotel/addInclusion';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  showSingleInclusion(reqModel): Observable<ResultModel> {
    const route = '/hotel/showSingleInclusion';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  updateInclusion(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateInclusion';
    return this.apiService.put<ResultModel>(route, reqModel);
  }

  updateOrderStatus(reqModel): Observable<ResultModel> {
    const route = '/hotel/manageOrderStatus';
    return this.apiService.put<ResultModel>(route, reqModel);
  }

  fetchInclusionList(reqModel): Observable<ResultModel> {
    const route = '/hotel/fetchInclusionList';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  singleInclusionDelete(reqModel): Observable<ResultModel> {
    const route = '/hotel/singleInclusionDelete';
    return this.apiService.delete<ResultModel>(route, reqModel);
  }

  addService(reqModel): Observable<ResultModel> {
    const route = '/hotel/addService';
    return this.apiService.post<ResultModel>(route, this.withPermissionRoute(reqModel, 'services'));
  }

  requestInventoryRestock(reqModel): Observable<ResultModel> {
    const route = '/hotel/inventoryRestock';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  inventoryRestockAdmin(reqModel): Observable<ResultModel> {
    const route = '/hotel/inventoryRestockAdmin';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  getInventoryRequest(reqModel): Observable<ResultModel> {
    const route = '/getInventoryRequest';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  inventoryRequestApproval(reqModel): Observable<ResultModel> {
    const route = '/hotel/inventoryRequestApproval';
    return this.apiService.put<ResultModel>(route, reqModel);
  }

  updateService(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateService';
    return this.apiService.put<ResultModel>(route, this.withPermissionRoute(reqModel, 'services'));
  }

  getBillingInfo(reqModel): Observable<ResultModel> {
    const route = '/hotel/get-billing-info';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  guestCheckoutPayment(reqModel): Observable<ResultModel> {
    const route = '/hotel/paymentMethod/checkout/fullPayment';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  deleteService(reqModel): Observable<ResultModel> {
    const route = '/hotel/service/delete';
    return this.apiService.delete<ResultModel>(route, this.withPermissionRoute(reqModel, 'services'));
  }

  showServiceListsAdmin(reqModel): Observable<ResultModel> {
    const route = '/hotel/showServiceLists';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'services'));
  }

  showServiceLists(reqModel): Observable<ResultModel> {
    const route = '/showServiceLists';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  showServiceIds(reqModel): Observable<ResultModel> {
    const route = '/hotel/showServiceIds';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'services'));
  }

  getHotelRequests(reqModel): Observable<ResultModel> {
    const route = '/hotel/showHotelRequest';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  addPayment(reqModel): Observable<ResultModel> {
    const route = '/hotel/paymentMethod/add';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'payment')
    );
  }

  deleteAccount(reqModel): Observable<ResultModel> {
    const route = '/hotel/paymentMethod/updatePaymenytConnection';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'payment')
    );
  }

  getPaymentMethod(reqModel): Observable<ResultModel> {
    const route = '/hotel/paymentMethod/paymentMethodDetails';
    return this.apiService.get<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'payment')
    );
  }

  showSingleServiceAdmin(reqModel): Observable<ResultModel> {
    const route = '/hotel/showSingleService';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'services'));
  }
  showSingleServiceAdminRequest(reqModel): Observable<ResultModel> {
    const route = '/request/showSingleService';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  showSingleService(reqModel): Observable<ResultModel> {
    const route = '/showSingleService';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  submitHygieneTask(reqModel): Observable<ResultModel> {
    const route = '/hotel/submitHygieneTask';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  revertSubmittedTask(reqModel): Observable<ResultModel> {
    const route = '/hotel/revertSubmittedTask';
    return this.apiService.put<ResultModel>(route, reqModel);
  }

  showOneTimeSubmittedTask(reqModel): Observable<ResultModel> {
    const route = '/hotel/showOneTimeSubmitedTask';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  showCurrentDaySubmittedTask(reqModel): Observable<ResultModel> {
    const route = '/hotel/showCurrentDaySubmitedTask';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  updateServiceRestaurantStatus(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateRestaurantServiceStatus';
    return this.apiService.put<ResultModel>(route, reqModel);
  }

  /************************Tours*****************************/
  addTour(reqModel): Observable<ResultModel> {
    const route = '/hotel/tours/add';
    return this.apiService.post<ResultModel>(route, this.withPermissionRoute(reqModel, 'tours'));
  }
  updateTour(reqModel): Observable<ResultModel> {
    const route = '/hotel/tours/update';
    return this.apiService.put<ResultModel>(route, this.withPermissionRoute(reqModel, 'tours'));
  }

  showToursListsAdmin(reqModel): Observable<ResultModel> {
    const route = '/hotel/tours/showToursLists';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'tours'));
  }
  showToursLists(reqModel): Observable<ResultModel> {
    const route = '/tour/showToursLists';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  showSingleTour(reqModel): Observable<ResultModel> {
    const route = '/tour/showSingleTour';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  showSingleTourAdmin(reqModel): Observable<ResultModel> {
    const route = '/hotel/tours/showSingleTour';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'tours'));
  }

  updateTourHomeStatus(reqModel): Observable<ResultModel> {
    const route = '/hotel/tours/updateTourHomeStatus';
    return this.apiService.put<ResultModel>(route, reqModel);
  }

  deleteTour(reqModel): Observable<ResultModel> {
    const route = '/hotel/tour/delete';
    return this.apiService.delete<ResultModel>(route, this.withPermissionRoute(reqModel, 'tours'));
  }

  /***********Module Categories (Generic for Tours, Restaurants, Services, etc.)************/
  addModuleCategory(reqModel): Observable<ResultModel> {
    const route = '/hotel/categories/add';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, this.categoryPermissionRoute(reqModel))
    );
  }

  updateModuleCategory(reqModel): Observable<ResultModel> {
    const route = '/hotel/categories/update';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, this.categoryPermissionRoute(reqModel))
    );
  }

  fetchModuleCategories(reqModel): Observable<ResultModel> {
    const route = '/hotel/categories/list';
    return this.apiService.get<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, this.categoryPermissionRoute(reqModel)),
      {
        preserveRequestLangKey: true
      }
    );
  }

  deleteModuleCategory(id: string, reqModel): Observable<ResultModel> {
    const route = `/hotel/categories/delete/${id}`;
    return this.apiService.delete<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, this.categoryPermissionRoute(reqModel))
    );
  }

  reorderModuleCategories(reqModel): Observable<ResultModel> {
    const route = '/hotel/categories/reorder';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, this.categoryPermissionRoute(reqModel))
    );
  }

  fetchModuleCategoriesPublic(reqModel): Observable<ResultModel> {
    const route = '/categories/list';
    return this.apiService.get<ResultModel>(route, reqModel, {
      preserveRequestLangKey: true
    });
  }

  fetchModuleDefaultCategory(reqModel): Observable<ResultModel> {
    const route = '/hotel/categories/default';
    return this.apiService.get<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, this.categoryPermissionRoute(reqModel))
    );
  }

  setModuleDefaultCategory(reqModel): Observable<ResultModel> {
    const route = '/hotel/categories/default';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, this.categoryPermissionRoute(reqModel))
    );
  }

  /***********Stripe************/
  addStripe(reqModel): Observable<ResultModel> {
    const route = '/hotel/stripe/add';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'payment')
    );
  }

  stripeDetail(reqModel): Observable<ResultModel> {
    const route = '/hotel/stripe/stripeDetail';
    return this.apiService.get<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'payment')
    );
  }

  /**************Get service title***********/
  addServiceTitle(reqModel): Observable<ResultModel> {
    const route = '/hotel/addServiceTitle';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'homepage-menu')
    );
  }

  getServiceTitle(reqModel): Observable<ResultModel> {
    const route = '/getServiceTitle';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  updateServiceHomeStatus(reqModel): Observable<ResultModel> {
    const route = '/hotel/service/updateServiceHomeStatus';
    return this.apiService.put<ResultModel>(route, reqModel);
  }

  /**************Get service title***********/
  addTourTitle(reqModel): Observable<ResultModel> {
    const route = '/hotel/tours/addTourTitle';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'homepage-menu')
    );
  }

  addNewsTitle(reqModel): Observable<ResultModel> {
    const route = '/hotel/news/addNewsTitle';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'homepage-menu')
    );
  }

  getTourTitle(
    reqModel,
    options?: { skipGlobalErrorPage?: boolean }
  ): Observable<ResultModel> {
    const route = '/tour/getTourTitle';
    return this.apiService.get<ResultModel>(route, reqModel, options);
  }

  /*******************Contact US***********************/
  addContact(reqModel): Observable<ResultModel> {
    const route = '/hotel/contact/add';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  getContact(reqModel): Observable<ResultModel> {
    const route = '/hotel/contact/get';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  getNewsTitle(
    reqModel,
    options?: { skipGlobalErrorPage?: boolean }
  ): Observable<ResultModel> {
    const route = '/news/getNewsTitle';
    return this.apiService.get<ResultModel>(route, reqModel, options);
  }

  //Department Services
  showServicesDepartment(reqModel): Observable<ResultModel> {
    const route = '/hotel/services-department/get';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'services'));
  }

  showRestaurantDepartment(reqModel): Observable<ResultModel> {
    const route = '/hotel/show-restaurant-department';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'restaurants'));
  }

  getHotelName(reqModel): Observable<ResultModel> {
    const route = '/showHotelLists';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  //  deleteHotel(reqModel): Observable<ResultModel> {
  //   const route = "/singleHotelDelete";
  //  return this.apiService.delete<ResultModel>(route, reqModel);
  //  }

  getGuestUpdatedList(reqModel): Observable<ResultModel> {
    const route = '/check-in/getGuestUpdatedDetails';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  getBillingInfoAdminService(reqModel): Observable<ResultModel> {
    const route = '/hotel/get-billing-info';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  getRestaurantOrderDetail(reqModel): Observable<ResultModel> {
    const route = '/hotel/orderDetails';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  updateRestaurantOrderComment(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateRestaurantOrderComment';
    return this.apiService.put<ResultModel>(route, reqModel);
  }

  getRestaurantOrderList(reqModel): Observable<ResultModel> {
    const route = '/guest/get-order-list';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  getRestaurantUserDetail(reqModel): Observable<ResultModel> {
    const route = '/guest/getGuestdata';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  RestaurantguestSignup(reqModel): Observable<ResultModel> {
    const route = '/guest/guestSignup';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  getMessageNotificationCount(reqModel, options?: { skipGlobalErrorPage?: boolean }): Observable<ResultModel> {
    const route = '/hotel/get-all-message-count';
    return this.apiService.get<ResultModel>(route, reqModel, options);
  }

  getMessageNotificationCountIndividual(reqModel): Observable<ResultModel> {
    const route = '/hotel/get-all-message-count-individual';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  AvailCheckinIdRequest(reqModel) {
    const route = '/guest/requestCheckinId';
    return this.apiService.post<ResultModel>(route, reqModel);
  }
  getCheckinrequestDetails(reqModel) {
    const route = '/guest/getCheckingIdRequestDetails';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  getCheckinrequestList(reqModel) {
    const route = '/hotel/guest-check-in-list';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  gethotelList(reqModel) {
    const route = '/hotel/room-list';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  getHotelTypeList(reqModel) {
    const route = '/hotel/room-type-list';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  getCheckinGuestView(reqModel) {
    const route = '/hotel/guest-check-in-datail';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  approveRejectGuest(reqModel) {
    const route = '/admin/confirmGuestCheckinRequest';
    return this.apiService.post<ResultModel>(route, reqModel);
  }
  resendCheckinDetails(reqModel) {
    const route = '/admin/resendGuestCheckinDetails';
    return this.apiService.post<ResultModel>(route, reqModel);
  }
  pendingCheckinRequestCount(reqModel, options?: { skipGlobalErrorPage?: boolean }) {
    const route = '/hotel/panding-guest-check-in-count';
    return this.apiService.get<ResultModel>(route, reqModel, options);
  }
  getSingleTaxDetails(reqModel) {
    const route = '/hotel/getSingleTaxDetails';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  getHostedCheckoutStatus(reqModel) {
    const route = '/hotel/paymentMethod/checkout/getHostedCheckoutStatus';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  AddopenAiApiKeyChatbot(reqModel) {
    const route = '/openAiApiKeyChatbot';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'Manage-Open-AI')
    );
  }
  getConnectionStatus(reqModel) {
    const route = '/ai/apikey';
    return this.apiService.get<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'Manage-Open-AI')
    );
  }
  deleteAiApidata(reqModel) {
    const route = '/deleteAiApidata';
    return this.apiService.put<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'Manage-Open-AI')
    );
  }
  updateOpenAiApiKeyChatbot(reqModel) {
    const route = '/updateOpenAiApiKeyChatbot';
    return this.apiService.put<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'Manage-Open-AI')
    );
  }
  getConnectionStatusGuest(reqModel) {
    const route = '/getOpenAiApiStatus';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  addNews(reqModel): Observable<ResultModel> {
    const route = '/hotel/news/add';
    return this.apiService.post<ResultModel>(route, this.withPermissionRoute(reqModel, 'news'));
  }
  updateNews(reqModel): Observable<ResultModel> {
    const route = '/hotel/news/updateNews';
    return this.apiService.put<ResultModel>(route, this.withPermissionRoute(reqModel, 'news'));
  }
  showNewsListsAdmin(reqModel): Observable<ResultModel> {
    const route = '/hotel/news/showNewsLists';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'news'));
  }
  showNewsLists(reqModel): Observable<ResultModel> {
    const route = '/news/showNewsLists';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  showSingleNews(reqModel): Observable<ResultModel> {
    const route = '/news/showSingleNews';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  deleteNews(reqModel): Observable<ResultModel> {
    const route = '/hotel/news/delete';
    return this.apiService.delete<ResultModel>(route, this.withPermissionRoute(reqModel, 'news'));
  }
  showSingleNewsAdmin(reqModel): Observable<ResultModel> {
    const route = '/hotel/news/showSingleNews';
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel, 'news'));
  }
  loginGuestCommunication(reqModel): Observable<ResultModel> {
    const route = '/guest/loginGuestCommunication';
    return this.apiService.post<ResultModel>(route, reqModel);
  }
  getGuestCommunication(reqModel): Observable<ResultModel> {
    const route = '/guest/getGuestCommunication';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  getGuestAllCommunication(reqModel): Observable<ResultModel> {
    const route = '/guest/getGuestAllCommunication';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  getAllEmployeeBook(reqModel): Observable<ResultModel> {
    const route = '/hotel/getAllEmployeeBook';
    return this.apiService.get<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'Manage-Employee-Handbooks')
    );
  }

  addEmployeeHandbook(reqModel): Observable<ResultModel> {
    const route = '/hotel/addEmployeeHandbook';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'Manage-Employee-Handbooks')
    );
  }

  deleteEmployeeBook(reqModel): Observable<ResultModel> {
    const route = '/hotel/deleteEmployeeBook';
    // Pass as plain query object so Route / Id / s3Key reach the backend ACL
    return this.apiService.delete<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'Manage-Employee-Handbooks') as any
    );
  }

  addAdditionalAiTopic(reqModel): Observable<ResultModel> {
    const route = '/addAdditionalAiTopic';
    return this.apiService.post<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'Manage-Open-AI')
    );
  }

  deleteAdditionalAiTopic(reqModel): Observable<ResultModel> {
    const route = '/deleteAdditionalAiTopic';
    return this.apiService.delete<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'Manage-Open-AI')
    );
  }

  getAdditionalAiTopic(reqModel): Observable<ResultModel> {
    const route = '/getAdditionalAiTopic';
    return this.apiService.get<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'Manage-Open-AI')
    );
  }

  updateAdditionalAiTopic(reqModel): Observable<ResultModel> {
    const route = '/updateAdditionalAiTopic';
    return this.apiService.put<ResultModel>(
      route,
      this.withPermissionRoute(reqModel, 'Manage-Open-AI')
    );
  }

  portalBotCommunication(reqModel): Observable<ResultModel> {
    const route = '/PortalBotCommunication';
    return this.apiService.post<ResultModel>(route, reqModel);
  }
  getPortalBotCommunication(reqModel): Observable<ResultModel> {
    const route = '/getPortalBotCommunication';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  getAllPortalBotCommunication(reqModel): Observable<ResultModel> {
    const route = '/getAllPortalBotCommunication';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  showAllGuests(reqModel): Observable<ResultModel> {
    const route = '/hotel/showAllGuests';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  showGuestBookings(reqModel): Observable<ResultModel> {
    const route = '/hotel/showGuestBookings';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  deleteDeactiveGuest(reqModel): Observable<ResultModel> {
    const route = '/hotel/deleteDeactiveGuest';
    return this.apiService.put<ResultModel>(route, reqModel);
  }
  getGuestAndBookingGuestDetails(reqModel): Observable<ResultModel> {
    const route = '/hotel/getGuestAndBookingGuestDetails';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  updateGuestInfo(reqModel): Observable<ResultModel> {
    const route = '/hotel/updateGuestInfo';
    return this.apiService.put<ResultModel>(route, reqModel);
  }
  showAllPreferences(reqModel): Observable<ResultModel> {
    const route = '/hotel/showAllPreferences';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  showAllPreferenceTypes(reqModel): Observable<ResultModel> {
    const route = '/hotel/showAllPreferenceTypes';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  guestRequestPreferences(reqModel): Observable<ResultModel> {
    const route = '/hotel/guestRequestPreferences';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  sendVerificationCode(reqModel): Observable<ResultModel> {
    const route = '/hotel/sendVerificationCode';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  otpVerification(reqModel): Observable<ResultModel> {
    const route = '/hotel/otpVerification';
    return this.apiService.post<ResultModel>(route, reqModel);
  }
  showAllRequestedPreferences(reqModel): Observable<ResultModel> {
    const route = '/hotel/showAllRequestedPreferences';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  showSingleRequestedPreference(reqModel): Observable<ResultModel> {
    const route = '/hotel/showSingleRequestedPreference';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  printRequestedPreferences(reqModel): Observable<ResultModel> {
    const route = '/hotel/printRequestedPreferences';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  showOneTimeSubmitedTask(reqModel): Observable<ResultModel> {
    const route = '/hotel/showOneTimeSubmitedTask';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  showCompleteTaskHistory(reqModel): Observable<ResultModel> {
    const route = '/hotel/showCompleteTaskHistory';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  printUncheckedTasks(reqModel): Observable<ResultModel> {
    const route = '/hotel/printUncheckedTasks';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  showHygieneIds(reqModel): Observable<ResultModel> {
    const route = '/hotel/showHygieneIds';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  showSelectedHygieneServices(reqModel): Observable<ResultModel> {
    const route = '/hotel/showSelectedHygieneServices';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  showAllStaff(reqModel): Observable<ResultModel> {
    const route = '/hotel/showAllStaff';
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  // ================= TAG APIs =================

  // Create Tag
  createTag(reqModel): Observable<ResultModel> {
    const route = '/hotel/tag/create';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  // Get All Tags
  getAllTags(reqModel): Observable<ResultModel> {
    const route = '/hotel/tag/list';
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  // Delete Tag
  deleteTag(id: string, reqModel): Observable<ResultModel> {
    const route = `/hotel/tag/delete/${id}`;
    return this.apiService.delete<ResultModel>(route, reqModel);
  }

  // Assign Tag to Message
  assignTagToMessage(reqModel): Observable<ResultModel> {
    const route = '/hotel/message-tag/assign';
    return this.apiService.post<ResultModel>(route, reqModel);
  }

  // Get Tags for Message
  getTagsByMessage(messageId: string, reqModel): Observable<ResultModel> {
    const route = `/hotel/message-tag/${messageId}`;
    return this.apiService.get<ResultModel>(route, reqModel);
  }

  // Remove Tag
  removeTag(reqModel): Observable<ResultModel> {
    const route = '/hotel/message-tag/remove';
    return this.apiService.delete<ResultModel>(route, reqModel);
  }
}
